import axios from 'axios';
import {
  ITEM_DOWNLOAD_TEMPLATE,
  ITEM_EXPORT_INVENTORY_V1,
  ITEM_SUMMARY_URL,
  ITEMS_TEMPLATE,
  DELETE_ITEM_BY_ID_V1,
  CREATE_ALL_OUTLET_ITEM,
  VALIDATE_SAVE_TO_ALL_OUTLET,
  CREATE_ALL_OUTLET_ITEM_INVENTORY,
  DELETE_ITEM_BY_ID_V3,
  GET_MODIFIERS_LIST,
  LIST_ITEM_URL_INVENTORY_V1,
  ITEM_BY_ID_INVENTORY_V1,
  UPDATE_ALL_OUTLET_BY_ID_V1,
  BRAND_BASE_URL,
  GET_ITEM_BY_ID_V2,
  DELETE_ITEM_BY_ID_INVENTORY_V1,
  UPDATE_ITEM_BY_ID_INVENTORY_V1,
  NEW_ITEM_URL_INVENTORY_V1,
  POST_ITEM_IMAGE_ECOMMERCE,
  GET_ECOMMERCE_CATEGORY,
  POST_ITEM_MAIN_IMAGE,
  DELETE_ITEM_ALL_OUTLET_BY_ID_INVENTORY_V1,
} from './constants';

const reject = (error) => {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
};

function commonReject(err) {
  let eobj;
  const { data } = err.response;
  if (data.errors && typeof data.errors === 'string') {
    eobj = new Error(data.errors);
  } else if (data.message && typeof data.message === 'string') {
    eobj = new Error(data.message);
  } else if (data.errors.length > 0) {
    eobj = new Error(data.errors[0]);
  }
  return Promise.reject(eobj);
}

export function getCustomerTemplate() {
  return axios
    .get(ITEM_DOWNLOAD_TEMPLATE, { withCredentials: true })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function getExportItem(params) {
  return axios
    .get(ITEM_EXPORT_INVENTORY_V1, {
      params,
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
export function getItemTemplate() {
  return axios.get(ITEMS_TEMPLATE, { withCredentials: true }).catch((error) => {
    return Promise.reject(new Error(error.message));
  });
}

export function getItems(queryparams) {
  return axios
    .get(LIST_ITEM_URL_INVENTORY_V1, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      params: { ...queryparams, is_mobile: false },
      withCredentials: true,
    })
    .catch((error) => {
      // TODO low show the error message maybe?
      if (error.response) {
        const obj: Error & { status?: string } = new Error(
          error.message as string
        );
        obj.status = error.response.status;
        return Promise.reject(obj);
      }
      return Promise.reject(new Error(error.message));
    });
}

export function getItemById(id, params?) {
  return axios
    .get(ITEM_BY_ID_INVENTORY_V1(id), { params, withCredentials: true })
    .catch(reject);
}

export function getItemByIdV2(id, params?) {
  return axios
    .get(GET_ITEM_BY_ID_V2(id), { params, withCredentials: true })
    .catch(reject);
}

export function getSummary(queryParams) {
  return axios
    .get(ITEM_SUMMARY_URL, { params: queryParams, withCredentials: true })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function putItemById(id, data, params?) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const postedData = { ...data, item: { ...data.item, updated_at: null } };
  return axios
    .put(ITEM_BY_ID_INVENTORY_V1(id), postedData, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function putItemAllOutlet(id, data, params?) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const postedData = { ...data, item: { ...data.item, updated_at: null } };
  return axios
    .put(UPDATE_ALL_OUTLET_BY_ID_V1(id), postedData, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function postItem(data, params?) {
  const postedData = {
    ...data,
    item: {
      ...data.item,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      updated_at: new Date(Date.now()),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      created_at: new Date(Date.now()),
    },
  };
  return axios
    .post(LIST_ITEM_URL_INVENTORY_V1, postedData, {
      params,
      withCredentials: true,
    })
    .catch(commonReject);
}

export function postCreateAllOutletItem(data, params) {
  const postedData = {
    ...data,
    item: {
      ...data.item,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      updated_at: new Date(Date.now()),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      created_at: new Date(Date.now()),
    },
  };
  return axios
    .post(CREATE_ALL_OUTLET_ITEM, postedData, { params, withCredentials: true })
    .catch(commonReject);
}

export function updateImageById(id, data, params) {
  return axios
    .put(UPDATE_ITEM_BY_ID_INVENTORY_V1(id), data, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function deleteItemByIdV1(id, params) {
  return axios
    .delete(DELETE_ITEM_BY_ID_V1(id), { params, withCredentials: true })
    .catch(reject);
}

export function deleteItemByIdV3(id, params) {
  return axios
    .delete(DELETE_ITEM_BY_ID_V3(id), { params, withCredentials: true })
    .catch(reject);
}

export function deleteItemByIdInventoryV1(id, params?) {
  return axios
    .delete(DELETE_ITEM_BY_ID_INVENTORY_V1(id), {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function deleteItemAllOutletByIdInventoryV1(id, params?) {
  return axios
    .delete(DELETE_ITEM_ALL_OUTLET_BY_ID_INVENTORY_V1(id), {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function getNewItem(id?, params?) {
  return axios
    .get(NEW_ITEM_URL_INVENTORY_V1, { params, withCredentials: true })
    .catch(reject);
}

export function validateSaveToAllOutlet(data, params?) {
  const postedData = {
    ...data,
    item: {
      ...data.item,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      updated_at: new Date(Date.now()),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      created_at: new Date(Date.now()),
    },
  };
  return axios
    .post(VALIDATE_SAVE_TO_ALL_OUTLET, postedData, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function postCreateAllOutletItemV3(data, params?) {
  const postedData = {
    ...data,
    item: {
      ...data.item,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      updated_at: new Date(Date.now()),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      created_at: new Date(Date.now()),
    },
  };
  return axios
    .post(CREATE_ALL_OUTLET_ITEM_INVENTORY, postedData, {
      params,
      withCredentials: true,
    })
    .catch(commonReject);
}

export function getModifiersList() {
  return axios
    .get(GET_MODIFIERS_LIST, { withCredentials: true })
    .catch((error) => {
      let eobj;
      if (error.response) {
        const { data } = error.response;
        if (data.errors) {
          eobj = new Error(data.errors);
        } else if (data.message) {
          eobj = new Error(data.message);
        } else {
          eobj = new Error(error.message);
        }
      } else {
        eobj = new Error(error.message);
      }
      return Promise.reject(eobj);
    });
}

export function getBrandList(params, outletId) {
  return axios
    .get(BRAND_BASE_URL(outletId), {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function postBrand(data, outletId, params) {
  return axios
    .post(BRAND_BASE_URL(outletId), data, { params, withCredentials: true })
    .catch(reject);
}

export function postItemImage(outletId, data, params?) {
  return axios
    .post(POST_ITEM_IMAGE_ECOMMERCE(outletId), data, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function postItemMainImage(outletId, data) {
  return axios
    .post(POST_ITEM_MAIN_IMAGE(outletId), data, {
      withCredentials: true,
      headers: {
        service: 'inventory',
      },
    })
    .catch(reject);
}

export function getEcommerceCategory() {
  return axios
    .get(GET_ECOMMERCE_CATEGORY, {
      withCredentials: true,
    })
    .catch(reject);
}
